module.exports = __webpack_public_path__ + "img/icon-dpd.74fa9fa8.svg";